import authenticationApiService from '../../services/api/AuthenticationApiService';

export default {
    namespaced: true,
    state: {
        token: '',
    },
    getters: {
        getToken(state) {
            return state.token;
        },
    },
    mutations: {
        setToken(state, token) {
            Object.assign(state, {
                token,
            });
        },
    },
    actions: {
        saveToken(context, token) {
            context.commit('setToken', token);
            context.commit('api/setToken', token, { root: true });
            localStorage.setItem('biopharma_token', token);
        },
        loadToken(context) {
            const token = localStorage.getItem('biopharma_token');

            if (token) {
                context.commit('setToken', token);
                context.commit('api/setToken', token, { root: true });
            }
        },
        removeToken(context) {
            context.commit('setToken', '');
            context.commit('api/setToken', '', { root: true });
            localStorage.removeItem('biopharma_token');
            localStorage.removeItem('uid');
        },
        async login(context, data) {
            const response = await authenticationApiService.login(data);

            const token = response && response.token ? response.token : '';

            const uid = response && response.user_id ? response.user_id : null;

            if (uid) localStorage.setItem('uid', uid);

            if (token) {
                context.dispatch('saveToken', token);
                this.dispatch('chart/drawGraph');
            }else {
                context.dispatch('message/show', {
                    type: 'error',
                    text: `${response.response.data.message}`,
                }, { root: true });
            }
        },
        logout(context) {
            context.dispatch('removeToken');

            const chartIndex = context.rootGetters['chart/getCharts'].findIndex(chart => chart.state === 'load');

            if (chartIndex !== -1) {
                context.commit('chart/removeChart', chartIndex, { root: true });
            }
        },
    },
};
